import React, { useState, useEffect, useRef, useCallback } from 'react';
import Header from '../../components/header/Header'
import Footer from '../../components/footer/Footer'
import PageHeading from '../../components/pageHeading/PageHeading'
import '../../jobHistory.scss'
import Paginate from '../../components/paginate/Paginate';
import { approveRejectJob, fetchAllJobs, fetchIncomingJobs } from '../../services/auth.service';
import JobContainer from './JobContainer';
import Search from '../../components/search/Search';
import { useDispatch } from 'react-redux';
import { setJobId, setLoader } from '../../slice/commonSlice';
import { toast } from "react-toastify";
import { toast_error, toast_success } from '../../config/Constant';
import { useNavigate } from 'react-router-dom';
import { provider_getProfile } from '../../services/auth.service';

const JobRequest = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('Incoming');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [jobList, setJobList] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [providerData, setProviderData] = useState();

  const listRef = useRef(null);
  const dispatch = useDispatch();

  const handleTabClick = (index) => {
    setActiveTab(index);
    if (dropdownOpen) {
      setDropdownOpen(false);
    }
  };

  const fetchProfileData = async () => {
    try {
      const response = await provider_getProfile();

      setProviderData(response?.data);
      // setLoading(false);
      await dispatch(setLoader(false));
    } catch (error) {
      // setLoading(false);
      await dispatch(setLoader(false));
    }
  };

  useEffect(() => {
    fetchProfileData()

    const handleClickOutside = (event) => {
      if (listRef.current && !listRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setSearchTerm('');
    setCurrentPage(1);
    if (activeTab === 'Incoming') {
      fetchIncomingJoblist(1);
    } else if (activeTab === 'Outgoing') {
      fetchOutgoingJoblist(1);
    }
  }, [activeTab])


  const fetchOutgoingJoblist = async (page, term = '') => {
    let payload = {
      "pageNumber": page,
      "search": term,
      "requestStatus": "accepted"
    }
    await dispatch(setLoader(true));
    try {
      const response = await fetchAllJobs(payload);
      await dispatch(setLoader(false));
      let outgoing = response.data?.jobs
      //?.filter((item)=>item.isQuoteSent === true);
      setJobList(outgoing);
      setTotalPages(response.data?.totalPages)
    } catch (error) {
      await dispatch(setLoader(false));

    }
  }

  const fetchIncomingJoblist = async (page, term = '') => {
    let payload = {
      "pageNumber": page,
      "search": term,
    }
    await dispatch(setLoader(true));
    try {
      const response = await fetchIncomingJobs(payload);
      await dispatch(setLoader(false));
      setJobList(response.data?.jobs);
      setTotalPages(response.data?.totalPages)
    } catch (error) {
      await dispatch(setLoader(false));

    }
  }

  const isValidProviderData = (providerData) => {
    return providerData?.provider?.bio?.trim() &&
      providerData?.provider?.marketingEmail !== null &&
      providerData?.bankDetails?.trim() &&
      providerData?.policyText?.trim() &&
      providerData?.provider?.location?.trim();
  };

  const updateJobRequest = async (id, status, isShareRequote = false) => {

    if (!providerData?.provider?.bio ||
      providerData?.provider?.bio === " " ||
      (providerData?.provider?.marketingEmail === null &&
        (providerData?.bankDetails === " " ||
          !providerData?.bankDetails) ||
        !providerData?.policyText ||
        !providerData?.provider?.location)) {

      // If any of the required fields are missing, return and show an error
      toast.error("Please complete your profile before accpeting the job request.", toast_error);
      return;
    }

    await dispatch(setLoader(true));

    if (isShareRequote) {
      dispatch(setJobId(id));
      navigate('/job/share-requote')
    } else {
      fetchIncomingJoblist(currentPage, searchTerm);
    }

    await dispatch(setLoader(false));
  }


  const rejectJobRequest = async (id, status, jobDetails, isShareRequote = false) => {


    if (!providerData?.provider?.bio ||
      providerData?.provider?.bio === " " ||
      (providerData?.provider?.marketingEmail === null &&
        (providerData?.bankDetails === " " ||
          !providerData?.bankDetails) ||
        !providerData?.policyText ||
        !providerData?.provider?.location)) {

      // If any of the required fields are missing, return and show an error
      toast.error("Please complete your profile before accpeting the job request.", toast_error);
      return;
    }

    let payload = {
      "jobId": id,
      "requestStatus": status

    }
    await dispatch(setLoader(true));
    try {
      const response = await approveRejectJob(payload);
      await dispatch(setLoader(false));
      if (response?.data?.status) {
        toast.success(response?.data?.message, toast_success)
        fetchIncomingJoblist(currentPage, searchTerm);
      }

    } catch (error) {
      toast.success(error?.data?.message, toast_error)
      await dispatch(setLoader(false));

    }
  }

  const handlePageChange = (page) => {
    setCurrentPage(page);
    if (activeTab === 'Incoming') {
      fetchIncomingJoblist(page, searchTerm);
    } else if (activeTab === 'Outgoing') {
      fetchOutgoingJoblist(page, searchTerm);
    }
  }

  const handleSearch = useCallback((term) => {
    setSearchTerm(term);
    setCurrentPage(1);
    if (activeTab === 'Incoming') {
      fetchIncomingJoblist(1, term);
    } else if (activeTab === 'Outgoing') {
      fetchOutgoingJoblist(1, term);
    }
  }, [setSearchTerm]);

  const handleAcceptAndShareQuote = (id) => {
    updateJobRequest(id, 'accepted', true)
  }

  return (
    <>
      <Header />
      <PageHeading title="Job Request" />
      <div className='main-container'>
        <div className='container-wrap'>
          <div className='job-history-header'>
            <div className='job-search'>
              <Search setSearchTerm={setSearchTerm} searchTerm={searchTerm} onSearch={handleSearch} />
            </div>
            <div className='job-nav'>
              <ul>
                <li className={`${activeTab === 'Incoming' ? 'active' : ''}`} onClick={() => handleTabClick('Incoming')}>Incoming</li>
                <li className={`${activeTab === "Outgoing" ? 'active' : ''}`} onClick={() => handleTabClick('Outgoing')}>Outgoing</li>

              </ul>
            </div>
          </div>
          <div className='job-tab-content-wrap'>
            {activeTab === 'Incoming' && <JobContainer type='incoming' acceptAndShare={handleAcceptAndShareQuote} rejectJobRequest={rejectJobRequest} list={jobList} />}
            {activeTab === 'Outgoing' && <JobContainer type='outgoing' list={jobList} />}
          </div>
          {jobList?.length > 0 &&
            <Paginate totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          }
        </div>
      </div>
      <Footer />
    </>
  )
}

export default JobRequest
